import { render, staticRenderFns } from "./CollapseMultiSelect.vue?vue&type=template&id=7a84579e&scoped=true&"
import script from "./CollapseMultiSelect.vue?vue&type=script&lang=ts&"
export * from "./CollapseMultiSelect.vue?vue&type=script&lang=ts&"
import style0 from "./CollapseMultiSelect.vue?vue&type=style&index=0&id=7a84579e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a84579e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VChip,VSelect})
